import React, { useState, useRef, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";

function Studentcorrection11() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!token) {
      navigate("/intermediate-admin");
    }
  }, []);

  const [formData, setFormData] = useState({
    passingYear: "2025",
    session: "",
    reg1: "",
    reg2: "",
    reg3: "",
    registration_number4: "",
  });
  const reg2Ref = useRef(null);
  const reg3Ref = useRef(null);

  const handleChange = (e) => {
    // debugger;
    const { name, value } = e.target;
    // const numericValue = value.replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Auto-focus forward
    if (name === "reg1" && value.length === 5) {
      reg2Ref.current.focus();
    }
    if (name === "reg2" && value.length === 4) {
      reg3Ref.current.focus();
    }
  };

  const handleBackspace = (e, fieldName) => {
    if (e.key === "Backspace" && formData[fieldName] === "") {
      if (fieldName === "reg3") {
        reg2Ref.current.focus();
      } else if (fieldName === "reg2") {
        document.querySelector("input[name='reg1']").focus();
      }
    }
  };
  const fullRegNo = `${formData.reg1}-${formData.registration_number4}-${formData.reg2}-${formData.reg3}`;

  const handleSearch = async (e) => {
    e.preventDefault();

    if (
      formData.reg1.length !== 5 ||
      formData.registration_number4 === "" ||
      formData.reg2.length !== 4 ||
      formData.reg3.length !== 2
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Registration Number",
        text: "Please enter the registration number correctly",
      });
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL2}/FetchDataStudentRegistrationByRegNo_CL12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            registratioN_NO: fullRegNo,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        // Pass entire data to next page
        navigate("/intermediate-demographic-details-update-page", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text:
            data.message || "No student found with this registration number.",
        });
        setLoading(false);
      }
    } catch (err) {
      console.error("API Error:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong.",
      });
      setLoading(false);
    }
  };
  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" />
                      Student Demographic Details Correction
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() =>
                            navigate("/intermediate-admin-dashboard")
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: "5px" }}
                          ></i>{" "}
                          Home
                        </a>
                      </li>
                      <li className="active">
                        Intermediate Student Correction
                      </li>
                    </ol>
                    <h3 />
                  </section>
                </div>
              </div>

              {/* ------------------ SEARCH SECTION ------------------ */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-center">
                      {/* Registration No Inputs */}
                      <div className="col-md-6">
                        <label className="mb-1">Registration Number</label>
                        <div class="row mt-2">
                          <div class="col-md-3">
                            <input
                              className="form-control form-control-xs"
                              name="reg1"
                              value={formData.reg1}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  handleChange(e);
                                }
                              }}
                              onKeyDown={(e) => handleBackspace(e, "reg1")}
                              maxLength="5"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            <p>5 Digits Only</p>
                          </div>
                          <div class="col-md-3">
                            <select
                              id="registration_number4"
                              name="registration_number4"
                              className="form-control form-select form-control-xs"
                              value={formData.registration_number4} // <-- bind value
                              onChange={handleChange} // <-- use the same handler
                              required
                            >
                              <option value="">Select</option>
                              <option value="RS">RS</option>
                              <option value="RC">RC</option>
                              <option value="RA">RA</option>
                              <option value="PC">PC</option>
                              <option value="PA">PA</option>
                            </select>
                          </div>
                          <div class="col-md-3">
                            <input
                              className="form-control form-control-xs"
                              name="reg2"
                              value={formData.reg2}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  handleChange(e);
                                }
                              }}
                              onKeyDown={(e) => handleBackspace(e, "reg2")}
                              maxLength="4"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              ref={reg2Ref}
                            />
                            <p>4 Digits Only</p>
                          </div>
                          <div class="col-md-3">
                            <input
                              className="form-control form-control-xs"
                              name="reg3"
                              value={formData.reg3}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  handleChange(e);
                                }
                              }}
                              onKeyDown={(e) => handleBackspace(e, "reg3")}
                              maxLength="2"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              ref={reg3Ref}
                            />
                            <p>2 Digits Only</p>
                          </div>
                        </div>
                      </div>

                      {/* Search Button */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-success"
                          style={{ marginTop: "5px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
export default Studentcorrection11;
